// extracted by mini-css-extract-plugin
export default {"title":"RecruitmentDetail_title__MPcBR","date":"RecruitmentDetail_date__3TZI5","icon":"RecruitmentDetail_icon__CQ3f9"};